import { SalesOrder_PaymentType, SalesOrder_ReceiptMethod } from '@proto/api/orders/resources';
import { StoreAddress_Type } from '@proto/api/common/common';

export enum ReceiptAction {
  NONE, // 已捐贈
  PREVIEW,
  DOWNLOAD,
  E_INV, // 發票整合平台
}

export class Orders {
  static isStore(paymentType: SalesOrder_PaymentType | undefined): boolean {
    return (
      paymentType === SalesOrder_PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN ||
      paymentType === SalesOrder_PaymentType.PAYMENT_TYPE_FAMILY_MART
    );
  }

  static isOversea(paymentType: SalesOrder_PaymentType | undefined): boolean {
    return (
      paymentType === SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA ||
      paymentType === SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA_CTBC
    );
  }

  static storeType(paymentType: SalesOrder_PaymentType): StoreAddress_Type {
    return !Orders.isStore(paymentType)
      ? StoreAddress_Type.TYPE_UNSPECIFIED
      : paymentType === SalesOrder_PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN
        ? StoreAddress_Type.TYPE_SEVEN
        : StoreAddress_Type.TYPE_FAMILY;
  }

  static receiptAction(receiptMethod: SalesOrder_ReceiptMethod, winning: boolean): ReceiptAction {
    let action = ReceiptAction.NONE;
    switch (receiptMethod) {
      case SalesOrder_ReceiptMethod.RECEIPT_METHOD_MEMBER_CARRIER: {
        action = ReceiptAction.PREVIEW;
        break;
      }
      case SalesOrder_ReceiptMethod.RECEIPT_METHOD_TAX_ID_NUMBER: {
        action = ReceiptAction.DOWNLOAD;
        break;
      }
      case SalesOrder_ReceiptMethod.RECEIPT_METHOD_MOBILE_BARCODE: {
        action = ReceiptAction.E_INV;
        break;
      }
      default:
        break;
    }
    if (winning) {
      action = ReceiptAction.PREVIEW;
    }
    return action;
  }
}
